<template>
  <div class="configure-filter__modal">
    <modal
      :active="true"
      :primary-button-disabled="processing"
      :primary-button-loading="processing"
      delete-button-label="Restore Defaults"
      tertiary-button-label="Cancel"
      primary-button-label="Apply"
      size="small"
      @onDelete="restoreDefaults()"
      @onClose="onClose()"
      @onConfirm="saveColumnConfig()">
      <template #header>
        <p>Configure Filter Columns</p>
      </template>
      <template #content>
        <div class="configure-filter__modal__body">
          <div class="configure-filter__modal__body__left">
            <div class="configure-filter__modal__body__left__header">
              Default Filters
            </div>
            <div
              v-for="(item, key) in configuration"
              :key="key"
              class="configure-filter__modal__body__left__title">
              <div
                v-if="item.isDefault"
                class="configure-filter__modal__body__left__title__tab">
                {{ key }}
              </div>
            </div>
          </div>
          <div class="configure-filter__modal__body__right">
            <div class="configure-filter__modal__body__right__header">
              Configuration
            </div>
            <div class="configure-filter__modal__body__right__search">
              <text-input
                id="filter-search-input"
                placeholder="Search for Column"
                :value="searchTerm"
                :show-clear-button="true"
                icon="magnifying-glass"
                @onChange="onSearch($event)"
                @onClear="onClear" />
            </div>
            <div class="configure-filter__modal__body__right__title">
              <div v-if="filteredCurrentConfigColumnsIndex.length">
                <div
                  v-for="item in filteredCurrentConfigColumnsIndex"
                  :key="item"
                  v-tooltip="getTooltip"
                  class="configure-filter__modal__body__right__title__column">
                  <div
                    class="configure-filter__modal__body__right__title__column__title">
                    <span
                      class="configure-filter__modal__body__right__title__column__title__value">
                      {{ item }}
                    </span>
                  </div>
                  <div
                    class="configure-filter__modal__body__right__title__column__icons">
                    <span
                      v-if="currentConfigColumns[item].isVisible"
                      class="mi-24px mi-eye"
                      aria-hidden="true"
                      @click="
                        toggleColumnVisibility(currentConfigColumns[item])
                      "></span>
                    <span
                      v-else
                      v-tooltip="
                        visibleNumber >= 30 &&
                        'Cannot show more than 30 columns'
                      "
                      class="mi-24px mi-eye-slash"
                      aria-hidden="true"
                      @click="
                        toggleColumnVisibility(currentConfigColumns[item])
                      "></span>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="configure-filter__modal__body__right__title__no-items-found">
                <span>No Items found, please use correct column names.</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "ConfigureFilterModal",
  directives: {
    ClickOutside,
  },
  props: {
    configuration: { type: Object, required: true },
    defaultColumns: { type: Array, required: true },
    cacheName: { type: String, default: "" },
  },
  data() {
    return {
      configColumns: [],
      processing: false,
      visibleNumber: 0,
      searchTerm: "",
      currentConfigColumns: {},
      filteredCurrentConfigColumnsIndex: [],
    };
  },
  computed: {
    ifSearchTermIsNotEmpty() {
      return this.searchTerm.length ? true : false;
    },
    getTooltip() {
      return this.searchTerm.length
        ? "You cannot change the postion while searching for columns"
        : "";
    },
  },
  watch: {
    searchTerm(keyword) {
      this.filteredCurrentConfigColumnsIndex = Object.keys(
        this.currentConfigColumns
      ).filter((i) => i.toLowerCase().indexOf(keyword.toLowerCase()) > -1);
    },
  },
  mounted() {
    const columnsCached = localStorage.getItem(`${this.cacheName}_for_columns`);
    let previousConfig = columnsCached ? JSON.parse(columnsCached) : null;
    const currentConfigColumns = previousConfig
      ? previousConfig
      : JSON.parse(JSON.stringify(this.configuration));
    this.currentConfigColumns = currentConfigColumns;
    this.filteredCurrentConfigColumnsIndex = Object.keys(currentConfigColumns);
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
      this.searchTerm = "";
    },
    toggleColumnVisibility(item) {
      let count = 0;
      Object.keys(this.currentConfigColumns).forEach((item) => {
        if (this.currentConfigColumns[item].isVisible) {
          count++;
        }
      });

      this.visibleNumber = count;

      if (count < 30) {
        item.isVisible = !item.isVisible;
      } else {
        item.isVisible = false;
      }
    },
    saveColumnConfig() {
      // showToast("success", "Applying Column Configuration");
      const newConfiguration = JSON.parse(
        JSON.stringify(this.currentConfigColumns)
      );
      this.$emit("onSaveColumnConfig", newConfiguration);
      localStorage.setItem(
        `${this.cacheName}_for_columns`,
        JSON.stringify(newConfiguration)
      );
      this.$emit("onModalClose");
      this.searchTerm = "";
    },
    restoreDefaults() {
      Object.keys(this.currentConfigColumns).forEach((item) => {
        this.currentConfigColumns[item].isVisible =
          this.defaultColumns.indexOf(item) > -1;
      });
    },
    onSearch(e) {
      this.searchTerm = e.target.value;
    },
    onClear() {
      this.searchTerm = "";
    },
  },
};
</script>

<style lang="scss">
.configure-filter__modal {
  & .modal--small {
    width: 648px;
    height: 648px;
    & .modal__content--padding {
      padding: 0;
    }
    & .modal__footer__buttons__left--underline {
      color: var(--invert-color);
    }
  }
  &__body {
    display: flex;
    justify-content: space-between;
    overflow-y: auto;
    padding: 1.5rem;
    padding-top: 0;
    margin-bottom: 1.5rem;
    @media (min-width: 1025px) {
      max-height: 510px;
      margin-bottom: 0;
    }
    &__left {
      display: flex;
      flex-direction: column;
      box-shadow: 0px 3px 5px -1px var(--black-variant-1),
        0px 1px 18px var(--black-variant-2), 0px 6px 10px var(--black-variant-1);
      border-radius: 4px;
      background-color: var(--f-card-bg-color);
      max-width: 12rem;
      width: 100%;
      overflow-y: auto;
      cursor: default;
      @media (max-width: 1024px) {
        display: none;
      }
      &__header {
        font-family: "Maersk Text Bold";
        font-size: 14px;
        line-height: 16px;
        color: var(--mx-date-picker-calendar-color);
        font-weight: 700;
        padding-left: 24px;
        padding-top: 24px;
      }
      &__title {
        font-family: "Maersk Text";
        font-size: 14px;
        line-height: 16px;
        color: var(--mx-date-picker-calendar-color);
        &__tab {
          box-sizing: border-box;
          padding: 12px 24px;
          white-space: nowrap;
        }
      }
    }
    &__right {
      margin-left: 16px;
      background-color: var(--f-card-bg-color);
      overflow-y: auto;
      box-shadow: 0px 3px 5px -1px var(--black-variant-1),
        0px 1px 18px var(--black-variant-2), 0px 6px 10px var(--black-variant-1);
      border-radius: 4px;
      width: 100%;

      &__header {
        font-family: "Maersk Text Bold";
        font-size: 14px;
        line-height: 16px;
        color: var(--mx-date-picker-calendar-color);
        font-weight: 700;
        padding-left: 24px;
        padding-top: 24px;
      }

      &__search {
        margin: 12px 22px 0px 26px;

        & .form-input__field {
          background-color: var(--f-card-form-input-color);
        }
      }

      &__title {
        display: flex;
        flex-direction: column;

        &__no-items-found {
          display: flex;
          justify-content: center;
          margin-top: 1rem;
          padding: 1rem 2rem;
        }

        &__column {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border: 1px solid var(--Gray-400);
          box-sizing: border-box;
          box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
          margin: 12px 22px 0px 26px;
          padding: 8px 16px;

          &:last-child {
            margin-bottom: 15px;
          }

          &__icons {
            cursor: pointer;
            display: flex;
            align-content: center;

            & span:first-child {
              margin-right: 0.5rem;
            }

            &__toggle-lock {
              &:focus {
                outline: none;
              }
            }

            &__disabled {
              cursor: not-allowed;
            }
          }

          &__title {
            font-family: "Maersk Text";
            font-size: 14px;
            color: var(--mx-date-picker-calendar-color);
            cursor: pointer;
            display: flex;
            align-items: center;

            span {
              margin-right: 0.5rem;
            }
          }
        }
      }
    }
  }
}
</style>
